import React from "react";
import { motion } from "framer-motion";

const ReviewsSkeleton = () => {
  const skeletonReviews = Array.from({ length: 3 }, (_, index) => index);

  return (
    <div className="space-y-6">
      {/* Header Skeleton */}
      <div className="flex justify-between items-center">
        <div className="h-8 bg-gray-600/50 rounded animate-pulse w-24"></div>
        <div className="h-10 bg-gray-600/50 rounded animate-pulse w-28"></div>
      </div>

      {/* Rating Statistics Skeleton */}
      <div className="bg-gray-900/30 rounded-xl p-6 border border-gray-600">
        <div className="flex items-center space-x-6">
          <div className="text-center">
            <div className="h-8 bg-gray-600/50 rounded animate-pulse w-12 mb-2"></div>
            <div className="flex items-center justify-center space-x-1 mt-1">
              {Array.from({ length: 5 }, (_, i) => (
                <div key={i} className="w-4 h-4 bg-gray-600/50 rounded animate-pulse"></div>
              ))}
            </div>
            <div className="h-4 bg-gray-600/50 rounded animate-pulse w-16 mt-2"></div>
          </div>

          <div className="flex-1">
            {Array.from({ length: 5 }, (_, i) => (
              <div key={i} className="flex items-center space-x-2 mb-1">
                <div className="w-4 h-4 bg-gray-600/50 rounded animate-pulse"></div>
                <div className="flex-1 bg-gray-700 rounded-full h-2">
                  <div className="bg-gray-600/50 h-2 rounded-full animate-pulse" style={{ width: `${Math.random() * 100}%` }}></div>
                </div>
                <div className="w-8 h-4 bg-gray-600/50 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Reviews List Skeleton */}
      <div className="space-y-4">
        {skeletonReviews.map((index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-gray-900/50 rounded-xl p-4 border border-gray-600"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gray-600/50 rounded-full animate-pulse"></div>
                <div className="h-4 bg-gray-600/50 rounded animate-pulse w-24"></div>
              </div>
              <div className="h-3 bg-gray-600/50 rounded animate-pulse w-16"></div>
            </div>
            <div className="flex items-center space-x-2 mb-2">
              {Array.from({ length: 5 }, (_, i) => (
                <div key={i} className="w-4 h-4 bg-gray-600/50 rounded animate-pulse"></div>
              ))}
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-600/50 rounded animate-pulse"></div>
              <div className="h-4 bg-gray-600/50 rounded animate-pulse w-3/4"></div>
              <div className="h-4 bg-gray-600/50 rounded animate-pulse w-1/2"></div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSkeleton;
